import { createSlice } from "@reduxjs/toolkit";
import { fetchPaymentOptions } from "../actions/paymentAction";



// Slice
const paymentSlice = createSlice({
  name: "payment",
  initialState: {
    options: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaymentOptions.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPaymentOptions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.options = action.payload;
      })
      .addCase(fetchPaymentOptions.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default paymentSlice.reducer;
